import React from 'react';
import { Pagination } from 'antd';

interface MobilePaginationComponentProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number, pageSize: number) => void;
  onShowSizeChange?: (current: number, size: number) => void;
  showSizeChanger?: boolean;
  pageSizeOptions?: string[];
  showTotal?: (total: number, range: [number, number]) => string;
  simple?: boolean;
}

export const MobilePaginationComponent: React.FC<MobilePaginationComponentProps> = ({
  current,
  total,
  pageSize,
  onChange,
  onShowSizeChange,
  showSizeChanger = false,
  pageSizeOptions = ['10', '20', '50', '100'],
  showTotal,
  simple = true,
}) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px',
      background: '#ffffff',
      borderTop: '1px solid #f0f0f0',
      boxShadow: '0 -2px 8px rgba(0,0,0,0.06)'
    }}>
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        onShowSizeChange={onShowSizeChange}
        showSizeChanger={showSizeChanger}
        pageSizeOptions={pageSizeOptions}
        showTotal={showTotal || ((total, range) => `Page ${current} of ${Math.ceil(total / pageSize)}`)}
        simple={simple}
        size="small"
        style={{
          fontSize: '14px'
        }}
      />
    </div>
  );
};
